import { Component, OnInit, Input, OnDestroy, SimpleChanges,SimpleChange } from '@angular/core';

@Component({
	selector: 'scale',
	templateUrl: './scale.component.html',
	styleUrls: ['./scale.component.scss']
})


export class ScaleComponent implements OnInit {
	@Input('showScale') showScale : boolean = undefined;
	@Input('scaleElements') scaleElements:Array<number>;
	@Input('scaleType') scaleType:string;
	@Input('scaleValue') scaleValue:number;

	_barCount = 48;
	_bars :Array<number>;


	get bars(){
		if(this.scaleElements !== undefined){
			return this.scaleElements;
		}
		return this._bars;
	}


	constructor() {
		this._bars = new Array<number>(this._barCount);
		this._bars.fill(0,0,this._barCount -1);
	}


	blinkBar(idx:number){
		this._bars[idx]=2;
	}



	showPercentage(percentage:number){

		this._bars.fill(0,0,this._barCount-1);
		let visibleBars = (percentage/100)*this._barCount;
		for(let i=0;i<this._barCount;i++){
			if(i < visibleBars){
				this._bars[i]=1;
			}else{
				this._bars[i]=0;
			}
		}
	}

	ngOnInit() {
		this._bars = new Array<number>(this._barCount);
		if(this.scaleValue != undefined && this.scaleValue != null){
			this.showPercentage(this.scaleValue*100);
		}
		if(this.scaleType == "loadinganimation"){
			console.log("starting loadinganimation.");
			this.startLoadingAnimation();
		}else{
			console.log("not showing loadinganimation... scaleType: "+this.scaleType);
		}
	}
	ngOnChange(changes: SimpleChanges){
		if(changes.scaleType){
			console.log("Changes.");
			console.log(changes);
		}
	}
	ngOnDestroy(){
		console.log("destroying.");
		this.stopLoadingAnimation();
	}

	_loadingBarAnimation:any;
	_loadingBarIndex:number=0;
	_loadingBarWidth:number=10;

	stopLoadingAnimation(){
		if(this._loadingBarAnimation){
			clearInterval(this._loadingBarAnimation);
		}
		console.log("Loadinganimation stopped.");
		
	}


	setBarValue(idx,value=0|1|2):boolean{
		if(idx >= 0 && idx < this._bars.length){
			this._bars[idx]=value;
			return true;
		}
		return false;
	}


	startLoadingAnimation(){
		this.stopLoadingAnimation();
		console.log("bar length:" +this._bars.length);
		this._loadingBarIndex = -1*this._loadingBarWidth;
		this._loadingBarAnimation=setInterval(
			()=>{
				for(let i=0;i<this._loadingBarWidth;i++){
					this.setBarValue(this._loadingBarIndex+i,0);	
				}
				this._loadingBarIndex++;
				if(this._loadingBarIndex >= this._bars.length){
					this._loadingBarIndex = -1* this._loadingBarWidth;
				}
				for(let i=0;i<this._loadingBarWidth;i++){
					this.setBarValue(this._loadingBarIndex+i,1);
				}
			}
			,50);
		
	}
	
}
